module.exports = __webpack_public_path__ + "img/piano.1e3f20c2.svg";